import React from 'react'
import { ReactComponent as IconNoContent } from 'images/icons/noContent.svg';

import clsx from 'clsx'
import styles from './NoContent.module.scss'
import { useTranslation } from 'react-i18next';

type Props = {
  className?: string
  title?: string
  message?: string
  small?: boolean
}

export default function NoContent({
  className,
  title,
  message,
  small,
}: Props) {

  const {t} = useTranslation() as any
  return (
    <div className={clsx(
      styles.noContent,
      small && styles.noContent_small,
      className,
    )}
    >
      <IconNoContent className={styles.icon} />
      <h2>{t(title || 'No content')}</h2>
      <span>{t(message || 'This user has not published any videos')}</span>
    </div>
  )
}
